type Fn = (lang: string) => void

let listener: Fn | undefined = undefined

export const i8nEvent = {
  addListener(fn?: Fn) {
    listener = fn
  },

  emit(lang: string) {
    if (listener == null) return
    listener(lang)
  },
}
